var _path, _path2, _path3, _path4, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgContacto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 511,
    height: 384,
    viewBox: "0 0 511 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38135 5C162.345 5 322.68 10.7157 483.467 10.7157",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M486.517 1.95264C486.517 26.2437 492.308 55.1763 503.042 78.0668C515.203 104 506.086 139.567 506.086 166.409C506.086 210.678 510 253.593 510 297.616C510 323.532 510 349.498 510 375.379",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M506.949 369.663C442.894 369.663 378.658 369.337 315.405 365.117C274.939 362.417 237.792 365.239 197.531 365.239C178.806 365.239 162.044 369.663 144.324 369.663C127.066 369.663 109.808 369.663 92.5494 369.663C64.9228 369.663 37.2961 369.663 9.66943 369.663",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7627 6.7157C2.7627 25.0579 2.7627 43.4 2.7627 61.7422C2.7627 89.0351 8.37735 114.081 12.7937 141.045C18.0297 173.014 12.5356 205.757 15.2603 237.881C19.3672 286.301 17.5625 334.519 17.5625 383",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 285.138,
    y2: -0.5,
    transform: "matrix(-0.806422 0.59134 -0.628504 -0.777806 487.941 7.66833)",
    stroke: "#767676",
    strokeOpacity: 0.46
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 311.375,
    y2: -0.5,
    transform: "matrix(0.828582 0.559868 -0.597215 0.802081 0 1.95264)",
    stroke: "#767676",
    strokeOpacity: 0.46
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgContacto);
export default __webpack_public_path__ + "static/media/imgContacto.ec6ade4588276ee2c5f4d00f8934bcb6.svg";
export { ForwardRef as ReactComponent };